import { Injectable } from '@angular/core';
import { getOrderId } from '@features/order-ui/utils/order.utils';
import { DateService } from '@rd/core/services/date/date.service';
import { NydusNetworkApiDataService } from '@rd/core/services/nydus-network-api-data/nydus-network-api-data.service';
import { PointsTransaction, Promocode } from '@rd/types';
import { CashRedemptionResponse } from '@rd/types/cash-redemption.response';
import { PointsTransactionModel } from '@rd/types/points-transaction.model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

interface CashbackPostParams {
  redemptionAmount: number;
  cashAmount: number;
  loyaltyProgramId: string;
}

@Injectable({
  providedIn: 'root',
})
export class CashbackApiService {
  constructor(
    private nydusNetworkApiService: NydusNetworkApiDataService,
    private dateService: DateService,
  ) {}

  postCashRedemption(
    cashRedemptionPostParams: CashbackPostParams,
    promocode?: Promocode,
  ): Observable<PointsTransaction> {
    return this.nydusNetworkApiService
      .post<CashRedemptionResponse>('cash_redemptions', {
        promo_code: promocode,
        cash_redemption: { ...cashRedemptionPostParams },
      })
      .pipe(
        map((cashRedemptionResponse) => {
          return this.transformCashRedemptionResponse(cashRedemptionResponse);
        }),
      );
  }

  private transformCashRedemptionResponse(
    cashRedemptionResponse: CashRedemptionResponse,
  ): PointsTransaction {
    const { data } = cashRedemptionResponse;
    return this.transformPointsTransactionModel(data);
  }

  // TODO: centralize all points activity model transformations into one service
  private transformPointsTransactionModel(
    pointsTransactionModel: PointsTransactionModel,
  ): PointsTransaction {
    const { id, attributes, relationships } = pointsTransactionModel;
    const {
      amount,
      balanceAsOf,
      category,
      description,
      status,
      orderFulfillmentStatus,
      productType,
      createdAt,
      transactionTime,
      metadata,
      orderItemData,
      entryType,
    } = attributes;

    const orderId = getOrderId(relationships);

    const transformedPointsTransaction = {
      id,
      amount,
      balance: balanceAsOf,
      category,
      descriptor: description,
      status,
      orderFulfillmentStatus,
      productType,
      createdAt: this.dateService.parseDate(createdAt),
      transactionTime: this.dateService.parseDate(transactionTime),
      metadata,
      orderItemData,
      entryType,
      orderId,
    };

    return transformedPointsTransaction;
  }
}
